/** Status URLs carry bearer tokens and must stay out of analytics. */
export function isPrivateStatusUrl(value: string) {
  try {
    const pathname = new URL(value, "https://agroproj.invalid").pathname;
    return pathname === "/andamento" || pathname.startsWith("/andamento/");
  } catch {
    return false;
  }
}
